import React from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import Button from 'olive-react-myoneui/lib/Button';

const MessageFullWidthBlock = ({ 
  icon,
  title, 
  message, 
  buttonText, 
  handleButtonClick,
  className
}) => {
  return (
    <div className={`${className || ''} thank-you-wrapper px-3`}>
      <Row className="justify-content-between align-items-center text-center">
        <Col lg={12} className="mb-4">
          {icon &&
            <span>{icon}</span>
          }
          {title &&
            <h1>{title}</h1>
          }
          {message &&
            <p>{message}</p>
          }
          {handleButtonClick &&
            <Button 
              variant="primary" 
              className="my-3 px-5 d-inline-flex align-items-center gap-2" 
              onClick={handleButtonClick}
            >
              <span>{buttonText}</span>
            </Button>
          }
        </Col>
      </Row>
    </div>
  );
};

export default MessageFullWidthBlock;
